// src/components/Gallery.js
import React, { useState, useEffect } from 'react';
import '../components/ImageGallery.css';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ImageGallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const fetchImages = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/api/images`);
      setImages(response.data);
    } catch (err) {
      console.error('Error fetching images:', err);
    } finally {
      setLoading(false);
    }
  };

  const openLightbox = (imageUrl, index) => {
    setSelectedImage(imageUrl);
    setCurrentIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const nextIndex = (currentIndex + 1) % images.length;
    setCurrentIndex(nextIndex);
    setSelectedImage(images[nextIndex].url || images[nextIndex]);
  };

  const prevImage = () => {
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setCurrentIndex(prevIndex);
    setSelectedImage(images[prevIndex].url || images[prevIndex]);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, currentIndex]);

  useEffect(() => {
    fetchImages();
  }, []);

  if (loading) {
    return (
      <div className="gallery-loading">
        <div className="loading-spinner"></div>
        <p>Loading images...</p>
      </div>
    );
  }

  return (
    <div className="professional-gallery">
      {/* Header */}
      <div className="gallery-header">
        <h1>Image Gallery</h1>
        {/* <p>{images.length} {images.length === 1 ? 'image' : 'images'}</p> */}
      </div>

      {/* Gallery Grid */}
      <div className='gallery-container'>
        <div className='gallery-grid'>
          {images.map((image, index) => {
            const imageUrl = image.url || image;
            const fileName = imageUrl.split('/').pop();
            
            return (
              <div className="gallery-item" key={index}>
                <div className="image-wrapper">
                  <img 
                    className='gallery-image' 
                    src={imageUrl} 
                    alt={`Gallery image ${index + 1}`}
                    onClick={() => openLightbox(imageUrl, index)}
                  />
                  <div className="image-overlay">
                    <button 
                      className="view-btn"
                      onClick={() => openLightbox(imageUrl, index)}
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    </button>
                  </div>
                </div>
                {/* <div className="image-info">
                  <span className="file-name">{fileName}</span>
                </div> */}
              </div>
            );
          })}
        </div> 
      </div>

      {/* Empty State */}
      {images.length === 0 && !loading && (
        <div className="empty-state">
          <div className="empty-icon">📷</div>
          <h3>No Images Yet</h3>
          <p>Upload some images to get started</p>
        </div>
      )}

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="lightbox-header">
              <span className="image-counter">
                {currentIndex + 1} / {images.length}
              </span>
              <button className="close-btn" onClick={closeLightbox}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Image */}
            <div className="lightbox-image-container">
              <img 
                src={selectedImage} 
                alt={`Gallery image ${currentIndex + 1}`}
                className="lightbox-image"
              />
            </div>

            {/* Navigation */}
            {images.length > 1 && (
              <>
                <button className="nav-btn prev-btn" onClick={prevImage}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button className="nav-btn next-btn" onClick={nextImage}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </>
            )}

            {/* Footer */}
            {/* <div className="lightbox-footer">
              <a 
                href={selectedImage} 
                download 
                className="download-btn"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Download
              </a>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;